var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group 3"},[React.createElement("circle",{"id":"Ellipse 1","cx":"21","cy":"21","r":"21","fill":"#003DA6","key":0}),React.createElement("path",{"id":"Facebook","d":"M22.1478 22.6541V29.8941H18.822V22.6541H16.0591V19.7184H18.822V18.6504C18.822 14.685 20.4785 12.6 23.9834 12.6C25.0579 12.6 25.3265 12.7727 25.9149 12.9134V15.817C25.2562 15.7019 25.0707 15.638 24.3864 15.638C23.5741 15.638 23.1392 15.8682 22.7426 16.3223C22.3461 16.7764 22.1478 17.5631 22.1478 18.6887V19.7248H25.9149L24.9044 22.6605H22.1478V22.6541Z","fill":"white","key":1})]));
}

IconFacebook.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
